export default __webpack_public_path__ + "static/media/gpr.b0a0fb1e.jpeg";